import { Box, Flex } from '@chakra-ui/react'
import { useMemo } from 'react'
import { usePatientPlanField, usePregnancyPlanField } from '../../hooks/insurance/fields'
import { StandaloneInput } from '../forms/Input'
import { useTemplateInsurancePlans } from '../Templates/contexts'

export const EditorCoverageSelect = () => {
  const { insurancePlans, selectPlan, selectedPlanId, pregnancyPlans } = useTemplateInsurancePlans()
  const hasPregnancyPlans = useMemo(() => !!pregnancyPlans?.primary, [pregnancyPlans])
  const field = usePatientPlanField(insurancePlans)
  const pregnancyPlanField = usePregnancyPlanField(pregnancyPlans)
  return (
    <Flex px={2} align="center" flex={1} minW="200px">
      <Box borderRadius={5} overflow="hidden" pt={1} w="100%">
        <StandaloneInput
          field={hasPregnancyPlans ? pregnancyPlanField : field}
          style={{
            padding: '0.25rem 0.4rem',
            border: '1px solid #cdcdcd',
            borderRadius: 5,
          }}
          value={selectedPlanId}
          onChange={id => selectPlan(id)}
        />
      </Box>
    </Flex>
  )
}
